import { FunctionComponent } from "react";

import { Box, Text } from "@chakra-ui/react";
import { BeatLoader } from "react-spinners";

export const LoadingContent: FunctionComponent = () => {
    return (
        <Box textAlign="center" py={10} px={6}>
            <BeatLoader color={"var(--chakra-colors-blue-700)"} size={10} />
            <Text fontSize="lg" color="blue.400">
                Route Guard...
            </Text>
        </Box>
    );
};
